import { injectIntl } from 'react-intl';

import { Banner, buttons } from '../../messages';
import ManageCookiesButton from '../ManageCookiesButton';
import withLgpdCookie from '../withLgpdCookie';

import styles from './CookieBanner.module.less';

const CookieBanner = ({
  intl,
  isClient,
  hasLgpdCookie,
  acceptCookies,
  rejectCookies,
}) => {
  if (!isClient) {
    return null;
  }
  return hasLgpdCookie ? null : (
    <div className={styles.root}>
      <div className={`ui container ${styles.content}`}>
        <p>
          <Banner />
        </p>

        <div className={styles.buttons}>
          <ManageCookiesButton
            className={`br-button small mr-2 ${styles.manage}`}
            label={intl.formatMessage(buttons.manageCookies)}
          />

          <button
            className="br-button secondary mr-2 dark-mode"
            onClick={() => rejectCookies()}
          >
            {intl.formatMessage(buttons.rejectCookies)}
          </button>

          <button
            className="br-button secondary dark-mode"
            onClick={() => acceptCookies()}
          >
            {intl.formatMessage(buttons.acceptCookies)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withLgpdCookie(injectIntl(CookieBanner));
